import routes from './routes';
import { PtBr, En, Es } from './locales';

const warehouseModule = {
    name: 'warehouse',
    routes,
    locales: {
        'pt-BR': PtBr,
        en: En,
        es: Es
    }
};

export default warehouseModule;
